import Cookies from 'js-cookie'
import { isLocalDev } from '@/utils'

export default {
  namespaced: true,
  state: {
    affiliateId: null,
    signInURL: `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin`,
    signUpURL: `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup`,
    modalDialog: {
      visible: false,
      count: 0
    },
    currentNavbar: null,
    currentNavbarTitle: '',
    insightTitle: '',
    pendingOrderCount: 0,
    newLeadsToday: 0,
    unitsSoldToday: 0,
    closedLeadsToday: 0,
    showSubscribeModal: false,
    lastIncomeTabPosition: 0,
    yezzapayMigrateModal: false,
    securepayMigrateModal: false,
    hasNewFeature: false,
    currentTopBarItems: [],
    displaySize: 'large',
    scrollbarWidth: 0,
    consultationHeightAdjustments: [
      { displaySize: 'x-large', patientHistory: -10, treatmentTable: 0, visitNote: 0 },
      { displaySize: 'large', patientHistory: -10, treatmentTable: 0, visitNote: 0 },
      { displaySize: 'medium', patientHistory: 10, treatmentTable: 250, visitNote: 250 },
      { displaySize: 'small', patientHistory: 50, treatmentTable: 520, visitNote: 520 },
      { displaySize: 'x-small', patientHistory: 95, treatmentTable: 550, visitNote: 900 },
      { displaySize: 'xx-small', patientHistory: 165, treatmentTable: 800, visitNote: 1280 },
    ]
  },
  mutations: {
    setAffiliateId (state, afId) {
      if (afId) {
        state.affiliateId = afId
        state.signInURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin?af_id=${afId}`
        state.signUpURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup?af_id=${afId}`
      } else {
        state.affiliateId = null
        state.signInURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin`
        state.signUpURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup`
      }
    },
    setProject (state, project) {
      if (project) {
        state.signInURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin?project=${project}`
        state.signUpURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup?project=${project}`
      } else {
        state.signInURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signin`
        state.signUpURL = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/signup`
      }
    },
    setRedirectPath (state, path) {
      let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
      if (isLocalDev()) {
        domain = window.location.hostname
      }
      if (path) {
        Cookies.set('yz_next_path', path, { domain })
      } else {
        Cookies.remove('yz_next_path', { domain })
      }
    },
    setDialogVisibility (state, visible) {
      let currentCount = state.modalDialog.count
      if (visible) {
        currentCount += 1
      } else if (currentCount >= 1) {
        currentCount -= 1
      }
      state.modalDialog.count = currentCount
      if (state.modalDialog.count >= 1) {
        state.modalDialog.visible = true
      } else {
        state.modalDialog.visible = false
      }
    },
    setCurrentNavbar (state, navbar) {
      state.currentNavbar = navbar
      let domain = `.${process.env.VUE_APP_BASE_DOMAIN}`
      let secure = true
      if (isLocalDev()) {
        domain = window.location.hostname
        secure = false
      }
      Cookies.set('yz_local_navbar', navbar, { secure, domain, expires: 90 })
    },
    setCurrentTopBarItems (state, items) {
      if (items) {
        state.currentTopBarItems = items
        localStorage.setItem('yz_top_bar_items', JSON.stringify(items))
      }
    },
    setNavbarTitle (state, title) {
      state.currentNavbarTitle = title
    },
    setInsightTitle (state, title) {
      state.insightTitle = title
    },
    setPendingOrderCount(state, count) {
      state.pendingOrderCount = count
    },
    setNewLeadsToday(state, count) {
      state.newLeadsToday = count
    },
    setUnitsSoldToday(state, count) {
      state.unitsSoldToday = count
    },
    setClosedLeadsToday(state, count) {
      state.closedLeadsToday = count
    },
    setShowSubscribeModal(state, show) {
      state.showSubscribeModal = show
    },
    setLastIncomeTabPosition(state, position) {
      state.lastIncomeTabPosition = position
      localStorage.setItem('yz_last_income_tab_position', position)
    },
    setYezzapayMigrateModal(state, status) {
      state.yezzapayMigrateModal = status
    },
    setSecurepayMigrateModal(state, status) {
      state.securepayMigrateModal = status
    },
    setHasNewFeature(state, status) {
      state.hasNewFeature = status
    },
    setDisplaySize (state, size) {
      state.displaySize = size
      localStorage.setItem('yz_display_size', size)
    },
    setInitDisplayConsultationHeightAdjustment (state) {
      const savedSize = localStorage.getItem('yz_display_size')
      const savedHeightAdjustment = JSON.parse(localStorage.getItem('yz_consultation_height_adjustment'))
      if (savedSize) {
        state.displaySize = savedSize
      }
      if (savedHeightAdjustment) {
        state.consultationHeightAdjustments = savedHeightAdjustment
      }
    },
    setConsultationPatientHistoryHeightAdjustment(state, adjustment) {
      let getHeight = state.consultationHeightAdjustments.find(f => f.displaySize === state.displaySize)
      if (getHeight) {
        getHeight.patientHistory += adjustment
      }
      localStorage.setItem('yz_consultation_height_adjustment', JSON.stringify(state.consultationHeightAdjustments))
    },
    setConsultationTreatmentTableHeightAdjustment(state, adjustment) {
      let getHeight = state.consultationHeightAdjustments.find(f => f.displaySize === state.displaySize)
      if (getHeight) {
        getHeight.treatmentTable += adjustment
      }
      localStorage.setItem('yz_consultation_height_adjustment', JSON.stringify(state.consultationHeightAdjustments))
    },
    setConsultationVisitNoteHeightAdjustment(state, adjustment) {
      let getHeight = state.consultationHeightAdjustments.find(f => f.displaySize === state.displaySize)
      if (getHeight) {
        getHeight.visitNote += adjustment
      }
      localStorage.setItem('yz_consultation_height_adjustment', JSON.stringify(state.consultationHeightAdjustments))
    },
    setScrollbarWidth(state, width) {
      state.scrollbarWidth = width
    }
  },
  getters: {
    getDisplaySize (state) {
      return state.displaySize
    },
    getScrollbarWidth (state) {
      return state.scrollbarWidth
    },
    getConsultationPatientHistoryHeightAdjustment(state) {
      let height = 0
      let getHeight = state.consultationHeightAdjustments.find(f => f.displaySize === state.displaySize)
      if (getHeight) {
        height = getHeight.patientHistory
      }
      return height
    },
    getConsultationTreatmentTableHeightAdjustment(state) {
      let height = 0
      let getHeight = state.consultationHeightAdjustments.find(f => f.displaySize === state.displaySize)
      if (getHeight) {
        height = getHeight.treatmentTable
      }
      return height
    },
    getConsultationVisitNoteHeightAdjustment(state) {
      let height = 0
      let getHeight = state.consultationHeightAdjustments.find(f => f.displaySize === state.displaySize)
      if (getHeight) {
        height = getHeight.visitNote
      }
      return height
    },
  }
}
